import React, { FC } from "react";
import CreateKnowledge from "./pages/CreateKnowledge";
import Dashboard from "./pages/Dashboard";
import Interact from "./pages/Interact";
import KnowledgeAssets from "./pages/KnowledgeAssets";
import HomeIcon from "@mui/icons-material/Home";
import SearchIcon from "@mui/icons-material/Search";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import DescriptionIcon from "@mui/icons-material/Description";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import NoteIcon from "@mui/icons-material/Note";
import CodeIcon from "@mui/icons-material/Code";
import ProjectDefinition from "./pages/ProjectDefinition";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import QaAutomation from "./pages/QaAutomation";
import WebhookIcon from "@mui/icons-material/Webhook";
import BiAutomation from "./pages/BiAutomation";
import Pseudocode from "./pages/Pseudocode";

interface Route {
  key: string;
  title: string;
  path: string;
  enabled: boolean;
  component: FC<{}>;
  index: number;
  icon: FC<{}>;
}

export const routes: Array<Route> = [
  {
    key: "home",
    title: "Home",
    path: `${process.env.PUBLIC_URL}/home`,
    enabled: true,
    component: Dashboard,
    index: 0,
    icon: HomeIcon,
  },

  {
    key: "project",
    title: "Browse Project",
    path: `${process.env.PUBLIC_URL}/browseProject`,
    enabled: true,
    component: ProjectDefinition,
    index: 1,
    icon: DescriptionIcon,
  },

  {
    key: "exploreknowledgeAssets",
    title: "Discovery",
    path: `${process.env.PUBLIC_URL}/discovery`,
    enabled: true,
    component: KnowledgeAssets,
    index: 2,
    icon: SearchIcon,
  },
  {
    key: "qaAuto",
    title: "QA Automation",
    path: `${process.env.PUBLIC_URL}/QaAutomation`,
    enabled: true,
    component: QaAutomation,
    index: 3,
    icon: SettingsSuggestIcon,
  },
  {
    key: "biAuto",
    title: "BI Automation",
    path: `${process.env.PUBLIC_URL}/BiAutomation`,
    enabled: true,
    component: BiAutomation,
    index: 4,
    icon: WebhookIcon,
  },
  {
    key: "pseduo",
    title: "Pseudocode",
    path: `${process.env.PUBLIC_URL}/Pseudocode`,
    enabled: true,
    component: Pseudocode,
    index: 5,
    icon: CodeIcon,
  },
  {
    key: "interact",
    title: "Ask Awgment",
    path: `${process.env.PUBLIC_URL}/askAwgment`,
    enabled: true,
    component: Interact,
    index: 6,
    icon: AutoAwesomeOutlinedIcon,
  },

  /* Add additional routes in Routes.ts as required following the above format: */
];
